import { compose, prop, sortBy, toLower } from 'ramda'
import us from 'us'

const sortByValue = sortBy(compose(toLower, prop('value')))

const MILITARY_TERRITORIES = [
  {
    label: 'AA',
    value: 'Armed Forces America',
  },
  {
    label: 'AE',
    value: 'Armed Forces Europe',
  },
  {
    label: 'AP',
    value: 'Armed Forces Pacific',
  },
  {
    label: 'PR',
    value: 'Puerto Rico',
  },
  {
    label: 'GU',
    value: 'Guam',
  },
  {
    label: 'VI',
    value: 'Virgin Islands',
  },
]

const STATES = us.STATES.map(({ abbr, name }) => ({
  label: abbr,
  value: name,
}))

export const STATE_ABBRS = Object.freeze(
  [...MILITARY_TERRITORIES.map(territory => territory.label), ...us.STATES.map(({ abbr }) => abbr)]
    .sort()
    .map(abbr => ({ label: abbr, value: abbr })),
)

export default Object.freeze(sortByValue([...MILITARY_TERRITORIES, ...STATES]))
